function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 22l10-8M10 17l10-8",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15z",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDashboardBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgDashboardBlue;